exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/** Colors */\n/** FlatUI Color Palette\n*\n*\tColor names based on FlatUI: https://flatuicolors.com/\n*/\n/** Acrylic Color Palette\n*\n*\tColor names based on Name that Color: http://chir.ag/projects/name-that-color\n*/\n.org-component-editor {\n  padding: 15px; }\n  .org-component-editor .tab-header {\n    margin-top: 10px;\n    margin-bottom: 10px; }\n  .org-component-editor .info {\n    font-size: 14px;\n    font-style: italic;\n    color: #aaaaaa; }\n", ""]);

// exports
